<template>
  <EditUbicazione
    :id="id"
    :idMagazzino="idMagazzino"
  />
</template>

<script>
import EditUbicazione from '@/components/MAGAZZINO/EditUbicazione.vue';

export default {
  name: 'EditUbicazioneView',
  props: ['id', 'idMagazzino', 'duplicateId'],
  components: {
    EditUbicazione,
  },
}
</script>